import styled from "styled-components/macro";

import { ActiveProfileQuery } from "operations";

const StyledAccountIndicator = styled.div`
  background-color: #b6ced0;
  height: 53px;
  padding: 0;
  position: relative;
  text-align: center;
  text-transform: uppercase;
  vertical-align: middle;
  width: 20px;
`;

const StyledAccountIndicatorText = styled.div`
  color: #323e48;
  font-size: var(--size-font-small);
  font-weight: bold;
  left: 50%;
  letter-spacing: normal;
  line-height: 1.4285em;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%) rotate(-90deg);
`;

const AccountIndicator = ({ account }: Pick<ActiveProfileQuery, "account">) => (
  <StyledAccountIndicator>
    <StyledAccountIndicatorText>
      {account.tier?.toUpperCase() ?? ""}
    </StyledAccountIndicatorText>
  </StyledAccountIndicator>
);

export const LoadingAccountIndicator = () => <StyledAccountIndicator />;

export default AccountIndicator;
